export const questionsDataMan = {
	gender: {
		options: {
			male: {
				value: 'male'
			},
			female: {
				value: 'female'
			}
		}
	},
	goal: {
		options: {
			lose_weight: {
				value: 'lose_weight'
			},
			gain_muscles: {
				value: 'gain_muscles'
			},
			body_tone_up: {
				value: 'body_tone_up'
			},
			gain_healthier_life: {
				value: 'gain_healthier_life'
			}
		}
	},
	activities_preferences: {
		options: {
			workout: {
				value: 'workout_man'
			},
			walking: {
				value: 'walking'
			},
			gym: {
				value: 'gym_man'
			},
			running: {
				value: 'running'
			},
			meditations: {
				value: 'meditations_man'
			},
			yoga: {
				value: 'yoga_man'
			},
			dance: {
				value: 'dance_man'
			}
		}
	},
	age: {
		options: {
			'18-29': {
				value: '18-29'
			},
			'30-39': {
				value: '30-39'
			},
			'40-49': {
				value: '40-49'
			},
			'50-59+': {
				value: '50-59+'
			}
		}
	},
	diet_type: {
		options: {
			all: {
				value: 'all',
				description: 'all_description_man'
			},
			vegetarian: {
				value: 'vegetarian',
				description: 'vegetarian_description_man'
			},
			vegan: {
				value: 'vegan',
				description: 'vegan_description_man'
			},
			keto: {
				value: 'keto',
				description: 'keto_description_man'
			}
		}
	},
	current_level: {
		options: {
			beginner: {
				value: 'beginner',
				description: 'beginner_description'
			},
			intermediate: {
				value: 'intermediate',
				description: 'intermediate_description'
			},
			advanced: {
				value: 'advanced',
				description: 'advanced_description'
			}
		}
	},
	zones: {
		options: {
			chest: {
				value: 'chest'
			},
			arms: {
				value: 'arms'
			},
			belly: {
				value: 'belly'
			},
			back: {
				value: 'back'
			},
			glutes: {
				value: 'glutes'
			},
			legs: {
				value: 'legs'
			}
		}
	},
	choose_days: {
		options: {
			monday: {
				value: 'monday'
			},
			tuesday: {
				value: 'tuesday'
			},
			wednesday: {
				value: 'wednesday'
			},
			thursday: {
				value: 'thursday'
			},
			friday: {
				value: 'friday'
			},
			saturday: {
				value: 'saturday'
			},
			sunday: {
				value: 'sunday'
			}
		}
	},
	fat: {
		options: {
			0: {
				value: '4-11%'
			},
			1: {
				value: '11-18%'
			},
			2: {
				value: '18-25%'
			},
			3: {
				value: '25-33%'
			},
			4: {
				value: '33-40%'
			},
			5: {
				value: '40-47%'
			},
			6: {
				value: '47-54%'
			},
			7: {
				value: '54+%'
			}
		}
	},
	health_issues: {
		options: {
			covid: {
				value: 'covid',
				description: 'covid_description'
			},
			jumps: {
				value: 'jumps',
				description: 'jumps_description'
			},
			back: {
				value: 'back',
				description: 'back_description'
			},
			arms: {
				value: 'arms',
				description: 'arms_description'
			},
			joints: {
				value: 'joints',
				description: 'joints_description'
			},
			knees: {
				value: 'knees',
				description: 'knees_description'
			},
			hernia: {
				value: 'hernia',
				description: 'hernia_description'
			},
			none: {
				value: 'none'
			}
		}
	},
	devices: {
		options: {
			dumbells: {
				value: 'dumbells'
			},
			barbell: {
				value: 'barbell'
			},
			treadmill: {
				value: 'treadmill'
			},
			bands: {
				value: 'bands'
			},
			none: {
				value: 'none'
			}
		}
	},
	previous_fails: {
		options: {
			motivation: {
				value: 'motivation'
			},
			plan: {
				value: 'plan'
			},
			hard: {
				value: 'hard'
			},
			coaching: {
				value: 'coaching'
			},
			none: {
				value: 'none'
			}
		}
	},
	successfully_lost_weight: {
		options: {
			yes: {
				value: 'yes'
			},
			no: {
				value: 'no'
			}
		}
	},
	muscle_focus: {
		options: {
			yes: {
				value: 'yes'
			},
			no: {
				value: 'no'
			}
		}
	},
	pushUps: {
		options: {
			beginer: {
				value: 'beginer'
			},
			intermediate: {
				value: 'intermediate'
			},
			advanced: {
				value: 'advanced'
			}
		}
	},
	weight: {},
	target_weight: {},
	height: {},
	mail: {},
	intermittent_fasting: {}
};
